import {z} from 'zod';

import {
  AddInterestAssignmentConditionRequestBody,
  InterestAssignmentConditionResponseBody,
  type UpdateInterestAssignmentConditionRequestBody,
} from '@dms/api/core';
import i18n from '@dms/i18n';

export const assignmentConditionFormSchema = z.object({
  name: z
    .string()
    .nonempty({message: i18n.t('general.errors.mixed.required')})
    .max(255),
  teamId: z.string().nonempty({message: i18n.t('general.errors.mixed.required')}),
  branchId: z.array(z.string().uuid()),
  make: z.array(z.string()).nullable(),
  model: z.array(z.string()).nullable(),
  modelFamily: z.array(z.string()).nullable(),
  condition: z.array(z.string()).nullable(),
  fuel: z.array(z.string()).nullable(),
  type: z.string().nullable(),
  sourceId: z.array(z.string().uuid()),
  mileageFrom: z.number().int().nullable(),
  mileageTo: z.number().int().nullable(),
});

export type AssignmentConditionFormValues = z.infer<typeof assignmentConditionFormSchema>;

function formValuesToMileage(values: AssignmentConditionFormValues) {
  const from = values.mileageFrom;
  const to = values.mileageTo;
  if (from === null && to === null) {
    return null;
  }
  return {from, to};
}

type RequestBody =
  | UpdateInterestAssignmentConditionRequestBody
  | AddInterestAssignmentConditionRequestBody;

export function formValuesToRequestBody(values: AssignmentConditionFormValues): RequestBody {
  return {
    teamId: values.teamId,
    name: values.name,
    branchId: values.branchId,
    make: values.make,
    model: values.model,
    modelFamily: values.modelFamily,
    condition: values.condition,
    fuel: values.fuel,
    type: values.type,
    sourceId: values.sourceId,
    mileage: formValuesToMileage(values),
  };
}

export function responseToFormValues(
  data: InterestAssignmentConditionResponseBody
): AssignmentConditionFormValues {
  return {
    name: data.name,
    teamId: data.teamId,
    branchId: data.branchId,
    make: data.make,
    model: data.model,
    modelFamily: data.modelFamily,
    condition: data.condition,
    fuel: data.fuel ?? null,
    type: data.type,
    sourceId: data.sourceId,
    mileageFrom: data.mileage?.from ?? null,
    mileageTo: data.mileage?.to ?? null,
  };
}
